import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Forward5Icon(props: IconProps) {
    return <Icon {...props} iconKey={"forward_5"}/>
}
